/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-10-08 16:31:29
 */
export default {
  lang: "英语",
  landing: {
    name1: "Відкрити Carlcare",
    name2: "Зарезервувати",
    name3: "За допомогою Carlcare ви в будь-який час можете перевірити своє замовлення.",
    name4: "",
    name5: "Проведіть пальцем управо",
    name6: "Перевірку завершено",
    name8: "Replace with Original & Guaranteed Battery", // 活动标题 副标题
    name9: "What is Flat Price Battery Replacement ?", // 标题
    name10: "The flat-price battery replacement service is designed for out-of-warranty Infinix/Tecno/itel designated models.",
    name11: "Starting from Rp.120K, you can get your battery replaced with no labor fee.",
    name12: 'Click the link to make a reservation or visit designated service centers to enjoy this hassle-free service.', // 小字标注
    name13: "Why Choose Carlcare Flat-Price Battery Replacement?",
    name14: "Original and Reliable",
    name15: "100% official spare parts perfectly fit your device.",
    name16: "Lower and Transparent Pricing",
    name17: "Enjoy a fixed, discounted price for the battery with no labor fee.",
    name18: "3-Month Warranty",
    name19: "Enjoy worry-free usage with a dependable warranty.",
    name20: "Fast and Easy On-Site Service",
    name21: "Quick and convenient battery replacement done face-to-face.",
    name22: "Worry-Free Repairs",
    name23: "Professional repairs with guaranteed long-lasting quality.",
    // name24: "1. Period: 2025.Jun9th-2025.Aug9th.",
    name25: "1. The replaced battery under this promotion comes with a 3-month official warranty.",
    name26: "2. This promotion is applicable for out-of-warranty battery replacements only.",
    name27: "3. If you join the flat-price battery promotion, you need agree to recycle the replaced original battery at the service center.",
    name28: "4. This promotion cannot be combined with other offers. Limited stock, while supplies last.",
    name29: "5. The promotion is currently available at selected stores only. For more details, please refer to the specific service locations.",
    name30: "6. Carlcare reserves the right to modify the promotion based on actual circumstances. For inquiries or assistance, please call Carlcare hotline at 02150880282.",
    name31: "Rules",
    name32: "Flat Price Battery",
    name33: "Replacement",
    name34: "From Rp120.000",
    name35: "Battery Price List",
    name36: "Brand",
    name37: "Series",
    name38: "Model",
    name39: "Price",
        name40: "Exclusive for",
    name41: "Jakarta Pusat!",
    name42: "Reservation Now",
    name43: "What is Carlcare Home Service ?",
    name44: "1.Carlcare Home Service is available for TECNO, Infinix, and itel users.",
    name45: "2.Enjoy convenient and efficient repair services anywhere (at home, in the office, at a café, on campus, or outdoors), saving you time and effort.",
    name46: "Why do we recommend choosing Carlcare Home Service ?",
    name47: "Free Home Service Charges",
    name48: "No home service fees required.",
    name49: "*For out of warranty or accidental damage, pay for parts and labor.",
    name50: "Easy Booking",
    name51: "Easily book through Carlcare App, website, hotline, or WhatsApp.",
    name52: "Safe & Reliable",
    name53: "With strict safety measures, ensuring your device is in trusted hands.",
    name54: "Official Support",
    name55: "All repairs by Carlcare official engineers use only original spareparts.",
    name56: "Ways to Book Carlcare Home Service",
    name57: "1. Open the Carlcare App",
    name58: '2. Tap "Reservation"',
    name59: '3. Choose "Carlcare Home Service"',
    name60: "4. Select your current location",
    name61: "5. Fill in the required details to complete the reservation",
    name62: "1. Open the Carlcare Official Website:https://www.carlcare.com/id/",
    name63: '2. Tap "Perbaiki Telepon"',
    name64: '3. Choose "Carlcare Home Service"',
    name65: "4. Select your current location",
    name66: "5. Fill in the required details to complete the reservation",
    name67: "Call Carlcare hotline: 021 5088 0282 to book Carlcare Home Service.",
    name68: "Contact Carlcare WhatsApp Business Account:+62-812-9009-0559 to Carlcare Home Service.",
    name69: "1.Device needs repair.",
    name70: "2.Book Carlcare Home Service.",
    name71: "3.Engineer contacts you to confirm the appointment time.",
    name72: "4.Engineer arrives at the scheduled time.",
    name73: "5.Complete the repair and make the payment.",
    name74: "Statement:",
    name75: "1.Free Home Service applies to service fees only. ",
    name76: "①Under Warranty: Enjoy free home service and repairs;",
    name77: "②Out of Warranty:Only pay for labor and spareparts,no extra home service charges.",
    name78: "2.Carlcare Home Service is currently limited to the the Jakarta Pusat and will gradually expand to more regions in the future. Please Stay tuned!",
    name79: "3.The final explanation of the activity belongs to Carlcare.",
    name80: "Carlcare App",
    name81: "Carlcare Website",
    name82: "Carlcare Hotline",
    name83: "Carlcare WhatsApp",
    name84: "No door-to-door fee",
    name85: "Service Process:",
  },
  order: {
    name1: "Виберіть модель пристрою",
    name2: "Опис несправності",
    name3: "Натисніть, щоб вибрати сервісний центр",
    name4: "Сервісний центр:",
    name5: "Час резервування:",
    name6: "Докладно опишіть проблему, що виникла у вашому пристрої.",
    name7: "Натисніть, щоб вибрати час прибуття",
    name8: "Введіть правильні контактні дані, щоб ми могли зв’язатися з вами",
    name9: "Доступний такий час бронювання:",
    name10: "Введіть свій номер телефону",
    name11: "Ціна",
    name12: "Особисті відомості:",
    name13: "Введіть своє ім’я",
    name14: "Надіслати",
    name15: "Скасувати",
    name16: "OK",
  },
  shops: {
    name1: "На основі обраного бренду вас можуть обслужити наступні магазини!",
    name2: "Незабаром і в інших роздрібних магазинах. Залишайтеся з нами!",
  },
  price: {
    name1: "Бренд",
    name2: "Модель",
    name3: "ЕЛЕМЕНТ",
    name4: "Ціна",
    name5: "Дружнє нагадування:",
    name6: "Ці ціни лише довідкові, а фактична ціна залежить від вашого пристрою.",
    name7: "Якщо спеціального символу немає, одиниця ціни - це місцева валюта.",
    name8: "Вибачте! Інформація про ціни в поточному регіоні недоступна.",
    name11:"Вартість роботи",
    name12:"Загальна сума",
    name13: "5. Якщо вартість роботи позначено знаком «/», це означає, що вартість роботи потрібно уточнити в магазині.",
    item_main_board: "Системна плата",
    item_screen_frame: "Екран (рамка)",
    item_screen_screen_frame: "Допоміжний екран (рамка)",
    item_touch_screen: "Сенсорний екран",
    item_camera: "Камера",
    item_fixed_focus_camera: "Камера з фіксованим фокусом",
    item_auto_focus_camera: "Камера з автоматичним фокусом",
    item_screen: "Екран",
    item_secondary_screen: "Допоміжний екран",
    item_fingerprint_module: "Модуль відбитка пальця",
    item_speaker: "Динамік",
    item_receiver: "Приймач",
    item_small_board: "Мала дошка",
    item_battery_cover: "Кришка відсіку акумулятора",
    item_battery: "Акумулятор",
    item_charger: "Зарядний пристрій",
    item_usb_cable: "USB-кабель",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "Немає даних",
    name2: "Постачальник послуг:",
    name3: "Бренд послуги:",
    name4: "Телефон:",
    name5: "Замовлена кількість:",
    name6: "Оцінка обслуговування",
    name7: "Середовище обслуговування:",
    name8: "Ставлення персоналу:",
    name9: "Ефективність обслуговування:",
    name10: "Якість обслуговування:",
    name11: "Оцінка клієнта",
    name12:"до",
    name13:"Закрито",
    name14:"Address:"
  },
  reserSuccess: {
    // name1:
    //   "Відкрити Carlcare",
    name1: "Зробіть знімок екрана з інформацією про бронювання та збережіть його як квитанцію для доступу до пріоритетного обслуговування.",
    name2: "Надіслано",
    name3: "1. Видаліть дані",
    name4: "Заздалегідь створіть резервну копію важливих особистих даних, що зберігаються у вашому телефоні",
    name5: "2. Зніміть пароль під час увімкнення живлення",
    name6: "Перш ніж іти в сервісний центр:",
    name7: "Сервісний центр:",
    name8: "Час резервування:",
    name9: "Опис несправності",
    name10: "Модель пристрою:",
    name11: "Номер замовлення:",
    name12: "Інформація про замовлення",
  },
  title: {
   
    name1: "Підтримує такі країни:",
    name2: "Вибрати модель",
    name3: "Резервування",
    name4: "Дані про сервісний центр",
    name5: "Вибрати сервісний центр",
  },
  error: {
    
    name1: "Немає даних. Перевірте інформацію про ремонт",
    name2: "Потрібна допомога?Зв\'яжіться з нами.",
    name3: "На жаль, у цьому регіоні немає центру Carlcare.",
    name4: "Спочатку виберіть сервісний центр",
    name5: "Не вдалося",
    name6: "Спочатку виберіть модель пристрою",
    name7: "Відомості",
    name8: "Докладно опишіть, що вам потрібно",
    name9: "",
  },
  add1:{
    "name0": "uk-rUA",
    "name1": "Ваше замовлення підтверджено. З нетерпінням чекаємо на ваш приїзд.",
    "name2": "Виберіть місто",
    "name3": "Введіть номер телефону з %1$s цифр.",
    "name4": "Будні години",
    "name5": "Понеділок",
    "name6": "Вівторок",
    "name7": "Середа",
    "name8": "Четвер",
    "name9": "П\\'ятниця",
    "name10": "Субота",
    "name11": "Неділя",
    "name12": "Введіть країну та виконайте пошук"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "pick-up time",
    "name7": "tap to select pick-up time",
    "name8": "pick-up address",
    "name9": "Pleasee input your house number/street/district/province",
    "name10": "Pleasee input postal code",
    "name11": "Add returning address",
    "name12": "returning address",
    "name13": "Інше",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
  },
  coupons: {
    name1:"Coupons",
    name2:"Натисніть, щоб перенаправити",
    name3:"Відкрийте програму Carlcare, щоб оцінити замовлення",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"Виберіть послугу",
    name7:"Безкоштовне чищення",
    name8:"Оновлення ПЗ",
  },
  cancelorder:{
    "cancelReason0": "Невірна інформація",
    "cancelReason1": "Неможливо прибути вчасно",
    "cancelReason2": "Дубльоване замовлення/не моє замовлення",
    "cancelReason3": "Помилка не виникає повторно",
    "cancelReason4": "Лише для випробування/запиту/події/…",
    "cancelReason5": "Висока ціна",
    "cancelReason6": "Брак матеріалу",
    "cancelReason7": "Відсутність диференційованих послуг",
    "cancelReason8": "Магазин розташований надто далеко",
    "cancelReason9": "Магазин закритий",
    "cancelReason10": "Низька якість обслуговування",
    "cancelReason11": "Заміна/ремонт продукції інших виробників",
    "cancelReason12": "Не вдалося знайти магазин",
    "cancelReason13": "Інше",
    "cancelOrder": "Скасувати замовлення",
    "reason_dialog_title": "Повідомте причину скасування",
    "Cancel": "Скасувати",
    "OK": "OK",
    "name1": "Введіть код перевірки",
    "name2": "Недійсний код перевірки",
    "repair_reservation_detail_canceled": "Це замовлення скасовано!",
    "purchase_cancel_dialog_content": "Підтверджуєте скасування замовлення?",
    "yes": "Так",
    "no": "Ні"
}
};
